import { FormBuilderDialog } from "#app/components/forms/form-builder/form-builder-dialog";
import { createDialogEmitter } from "#app/lib/dialog-emitter";

export type FormBuilderTarget = {
  formId: string;
  onClose?: () => void;
};

type FormBuilderDialogActions = {
  openFormBuilder: (formId: string, options?: { onClose?: () => void }) => void;
};

// A route's effect runs before the layout mount subscribes; the emitter holds that target.
const formBuilderDialog = createDialogEmitter<FormBuilderTarget>("form_builder");

const FORM_BUILDER_ACTIONS: FormBuilderDialogActions = {
  openFormBuilder: (formId, options) =>
    formBuilderDialog.open(options?.onClose ? { formId, onClose: options.onClose } : { formId }),
};

export function useFormBuilderDialogActions(): FormBuilderDialogActions {
  return FORM_BUILDER_ACTIONS;
}

export function FormBuilderDialogMount() {
  const { open, payload: target } = formBuilderDialog.useDialogState();

  const close = () => {
    formBuilderDialog.close();
    target?.onClose?.();
  };

  const swapForm = (formId: string) => formBuilderDialog.open(target ? { ...target, formId } : { formId });

  return (
    <FormBuilderDialog
      formId={open ? (target?.formId ?? null) : null}
      onClose={close}
      onOpenForm={swapForm}
      open={open}
    />
  );
}
